import React from "react";
import { CaseList, Container, Line, Title } from "./style";
import CaseCard from "@components/CaseCard";
import { casesList } from "@utils/constant/casesList";
import { useHistory, useLocation } from "react-router-dom";
import SearchCase from "@components/SearchCase";
import Layout from "@components/Layout";
const Home = () => {
  const history = useHistory();
  const location = useLocation();
  console.log(location);
  const handleSelect = (type: number, title: string, color: string) => {
    const location = {
      pathname: "/create",
      state: { type, title, color },
    };
    history.push(location);
  };
  return (
    <Layout>
      <Container>
        <SearchCase />
        <Title>Radicar Nuevo Caso</Title>
        <Line />
        <CaseList>
          {casesList.map((value) => (
            <CaseCard handleSelect={handleSelect} {...value} />
          ))}
        </CaseList>
      </Container>
    </Layout>
  );
};

export default Home;
